import { toCamelCase, toSnakeCase } from '@src/utils/string'
import { mapKeys } from '@src/utils/object'

// TODO: recursive
export const snakeKeys = mapKeys(toSnakeCase)

// TODO: recursive
export const camelKeys = mapKeys(toCamelCase)
